<script setup lang="ts">
import { type EpcGesClass, EPC_GES_CLASS_VALUES } from '@@/shared/property/epc-ges';

const modelValue = defineModel<Array<EpcGesClass>>({ default: [] });
</script>

<template>
  <div>
    <IadChipGroup
      v-model="modelValue"
    >
      <IadChip
        v-for="epcClass in EPC_GES_CLASS_VALUES"
        :key="epcClass"
        :label="epcClass"
        :value="epcClass"
      />
    </IadChipGroup>
  </div>
</template>
